export default {
  roomGroupList: (state, getters, rootState, rootGetters) => {
    if(Object.keys(rootGetters['room/room']).length === 0) return false

    return rootState.room.roomGroupList
  },
  roomGroupListNoDefault: (state, getters) => {
    let roomGroupListNoDefault = getters.roomGroupList.filter(roomGroup => roomGroup.roomGroupId !== 'default')

    return roomGroupListNoDefault
  },
  roomGroupListNoDefaultActive: (state, getters) => {
    let roomGroupListNoDefaultActive = getters.roomGroupList.filter(roomGroup => roomGroup.roomGroupId !== 'default' && (roomGroup.del !== undefined && !roomGroup.del))

    return roomGroupListNoDefaultActive
  },

  roomGroupListActive: (state, getters) => {
    let roomGroupListActive = getters.roomGroupList.filter(roomGroup => !roomGroup.del)

    return roomGroupListActive
  },
  getRoomGroup: (state, getters) => (roomGroupId) => {
    let roomGroup = getters.roomGroupList.find(rg => rg.roomGroupId == roomGroupId);
    return roomGroup;
  },
  isInRoomGroup: (state, getters, rootState, rootGetters) => (roomUser) => {
    if(!roomUser) roomUser = rootGetters['user/me']
    return rootGetters['room/isRoomMode']('group') && roomUser.roomGroupId && roomUser.roomGroupId !== 'default'
  },
  isModalSubject: (state) => {
    return state.isModalSubject
  },
  subjectRoomGroupId: (state) => {
    return state.subjectRoomGroupId
  },
  getRoomGroupName: (state, getters) => (roomGroupId) => {
    let roomGroup = getters.getRoomGroup(roomGroupId)
    return roomGroup && (roomGroup.roomGroupName || '그룹'+roomGroupId.substring(roomGroupId.indexOf('-')+1) )
  },
  getRoomGroupMode: (state, getters) => (roomGroupId) => {
    let roomGroup = getters.getRoomGroup(roomGroupId);
    return roomGroup?.mode;
  },
  isNewUser: (state, getters) => {
    return state.isNewUser
  },
  loadingGroupMode: (state) => {
    return state.loadingGroupMode
  },
  selectedPin: (state) => {
    return state.selectedPin
  },
  selectedUserIdList: (state) => {
    return state.selectedUserIdList
  },
  isSetNewGroup: (state) => {
    return state.isSetNewGroup
  },
  noContentGroupMode: (state, getters) => {
    let idx = getters.roomGroupListNoDefaultActive.findIndex(rg => !!rg.mode);

    return idx < 0;
  },
  roomGroupMicMuteState: (state, getters) => (roomGroupId) => {
    let roomGroup = getters.getRoomGroup(roomGroupId)
    return roomGroup && roomGroup.micMuteState
  },
  roomGroupSpeakerMuteState: (state, getters) => (roomGroupId) => {
    let roomGroup = getters.getRoomGroup(roomGroupId)
    return roomGroup && roomGroup.speakerMuteState
  }
}